import { render, staticRenderFns } from "./BeianRecordLine.vue?vue&type=template&id=08f829aa&scoped=true"
import script from "./BeianRecordLine.vue?vue&type=script&lang=js"
export * from "./BeianRecordLine.vue?vue&type=script&lang=js"
import style0 from "./BeianRecordLine.vue?vue&type=style&index=0&id=08f829aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f829aa",
  null
  
)

export default component.exports